<template>
  <div class="gdpr-toast">
    <div class="gdpr-toast__content">
      <p>
        {{ description }}
      </p>
    </div>
    <div class="gdpr-toast__actions">
      <div class="gdpr-toast__actions--left">
        <slot name="left"></slot>
      </div>
      <div class="gdpr-toast__actions--right">
        <slot name="right"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GDPRToast",
  props: {
    description: {
      type: String,
      default: undefined
    }
  }
};
</script>

<style lang="scss" scoped>
.gdpr-toast {
  background-color: rgba(theme-color("body"), 0.92);
  border-radius: sizes("border-radius-s");
  box-shadow: theme-color("shadow");
  color: theme-color("accent-1");
  display: block;
  padding: spacer("m");
  width: 100%;

  &__content {
    font-size: font-size("mini");
    margin-bottom: spacer("s");
  }

  &__actions {
    display: flex;
    justify-content: space-between;
    margin: spacer("xs") * -1;

    &--left {
      display: flex;
      justify-content: flex-start;
    }

    &--right {
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>
